import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import cookie from "js-cookie";
import fetcher from "../../../../../dataProvider";
import TagManager from "react-gtm-module";

import { useRouter } from "next/router";

import { GEOLOCATION_URL } from "../../../../../constant/appConstants";
import auth from "../../../../../../components/Layout/util/auth";

const SignUpForm = ({ recaptchaRef, toggleSnackbar, setIsSignUp }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setError,
  } = useForm();

  const router = useRouter();

  const [location, setLocation] = useState("");
  const r = auth();

  useEffect(() => {
    getUserLocation();
  }, []);

  const { mutate: getUserLocation } = useMutation(
    () => fetcher.get(GEOLOCATION_URL),
    {
      onSuccess: (result) => {
        setLocation(result);
      },
      onError: (error) => {
        setLocation({});
      },
    }
  );

  const onFormSubmit = async (data) => {
    const token = await recaptchaRef?.current?.executeAsync();
    recaptchaRef?.current?.reset();

    let userObject = {
      name: data.name,
      email: data.username,
      password: data.password,
      role: "user",
      token,
      location,
      googleAnalyticsId: [cookie.get("_ga")],
    };
    let userInviteCode = localStorage?.getItem("inviteCode");
    if (userInviteCode && userInviteCode.length == 6) {
      userObject.referralCode = userInviteCode;
    }
    signUpApi(userObject);
  };

  const { mutate: signUpApi } = useMutation(
    (user) => fetcher.post(`v1/user`, user),
    {
      onSuccess: (data) => {
        if (typeof window !== "undefined") {
          localStorage.setItem("userCreatedTime", data?.createdAt);
        }
        const tagManagerArgs = {
          dataLayer: {
            event: "register",
            Status: "Success",
            Method: "Email Sign up",
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        if (data) {
          toggleSnackbar({
            show: true,
            status: "success",
            message: "Account created , please Login",
          });
          if (typeof window !== "undefined") {
            localStorage.setItem("EmailToBeVerify", data?.email);
          }
          router.push("/email-verification");
          setIsSignUp(false);
        }
      },
      onError: (error) => {
        const tagManagerArgs = {
          dataLayer: {
            event: "register",
            Status: "failed",
            Method: "Email Sign up",
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        if (error?.response?.status == 409) {
          setError("username", {
            type: "custom",
            message: "Email is already registered.",
          });

          return;
        }

        if (error?.response?.status) {
          setError("confirmPassword", {
            type: "custom",
            message: error?.response?.data?.message,
          });
        }
      },
    }
  );
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  const handleSignupclick = () => {
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "loggedIn",
          ctaName: "Sign Up",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "Guest",
          ctaName: "Sign Up",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const [agree, setAgree] = useState(true);

  const checkboxHandler = () => {
    setAgree(!agree);
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <div className="inputBox">
        <input
          type="text"
          placeholder="Name*"
          {...register("name", { required: "Enter Name" })}
        />
        {errors.name && (
          <span style={{ color: "red" }}>{errors.name.message}</span>
        )}
      </div>
      <div className="inputBox">
        <input
          type="text"
          placeholder="Email*"
          {...register("username", { required: "Enter Email" })}
        />
        {errors.username && (
          <span style={{ color: "red" }}>{errors.username.message}</span>
        )}
      </div>
      <div className="inputBox">
        <input
          type="password"
          placeholder="Enter Password*"
          {...register("password", { required: "Enter Password" })}
        />
        {errors.password && (
          <span style={{ color: "red" }}>{errors.password.message}</span>
        )}
      </div>
      <div className="inputBox">
        <input
          type="password"
          placeholder="Confirm Password*"
          {...register("confirmPassword", {
            required: "Enter Confirm Password",
            validate: (val) => {
              if (watch("password") != val) {
                return "Password does not match";
              }
            },
          })}
        />
        {errors.confirmPassword && (
          <span style={{ color: "red" }}>{errors.confirmPassword.message}</span>
        )}
      </div>
      <div className="checkbox_text_login_signup">
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginTop: "6px",
          }}
        >
          <input
            type="checkbox"
            style={{ width: "15px", position: "relative", top: "4px" }}
            id="agree"
            defaultChecked={agree}
            onChange={checkboxHandler}
          />
          <label style={{ fontSize: "14px", marginLeft: "5px" }}>
            {" "}
            I agree to{" "}
            <span
              style={{ cursor: "pointer", color: "#e14084" }}
              onClick={() => window.open("/terms", "_blank")}
            >
              T&#38;C{" "}
            </span>
            and{" "}
            <span
              style={{ cursor: "pointer", color: "#e14084" }}
              onClick={() => window.open("/privacy", "_blank")}
            >
              Privacy Policy{" "}
            </span>
            and to receive communication &#47; notifications on email &#47;
            WhatsApp &#47; SMS from FanTiger.
          </label>
        </div>
      </div>
      <div className="login-button01" onClick={() => handleSignupclick()}>
        <button type="submit" className="btn" disabled={!agree}>
          Sign up
        </button>
      </div>
    </form>
  );
};

export default SignUpForm;
